module.exports = __webpack_public_path__ + "static_pc/img/7.8c91af04.png";